<template>
  <div id="mapOL" class="mapOL"></div>
</template>

<script>
// import { getFeatures } from "../data/openlayers-map";
import "ol/ol.css";
import VectorLayer from "ol/layer/Vector";
import VectorSource from "ol/source/Vector";
import { Circle as CircleStyle, Fill, Stroke, Style } from "ol/style";
import { Point } from "ol/geom";
import Feature from "ol/Feature";
import Map from "ol/Map.js";
import View from "ol/View.js";
import TileLayer from "ol/layer/Tile.js";
import OSM from "ol/source/OSM";
import { fromLonLat } from "ol/proj";
import Select from "ol/interaction/Select";
import { click, pointerMove } from "ol/events/condition";

// select interaction working on "click"
var selectClick = new Select({
  condition: click,
});

// select interaction working on "pointermove"
var selectPointerMove = new Select({
  condition: pointerMove,
});

export default {
  name: "map-openlayers",
  methods: {
    callCalculateMap: function(sources) {
      // console.log(sources);
      var date = Date.now;
      // this.vectorSource.clear();
      this.vectorSource.addFeatures(this.getFeatures(date, sources));
    },
    handleClick: function(e) {
      var features = e.target.getFeatures();
      if (features.array_.length >= 1) {
        var id = features.array_[0].values_.id;
        console.log("clicked id: " + id);
      } else {
        id = null;
      }
      this.selectedIds.push(id);
    },
    createFeatureForDate: function(source, date) {
      console.log("picking measurement closest to date: " + date);
      var measurement = source["measurements"][0];
      return new Feature({
        geometry: new Point(fromLonLat([source.xCoor, source.yCoor])),
        size: "8",
        id: source["id"],
        name: source["name"],
        height: measurement["height"],
        volume: measurement["volume"],
      });
    },
    getFeatures: function(date, sources) {
      var features = [];
      sources.forEach((source) => {
        console.log(`looking at source: ${JSON.stringify(source)}`);
        var feature = this.createFeatureForDate(source, date);
        features.push(feature);
      });
      console.log(`created features with ${features.length} features`);
      return features;
    },
    initMap: function() {
      var styles = {
        "8": new Style({
          image: new CircleStyle({
            radius: 4,
            fill: new Fill({ color: "blue" }),
            stroke: new Stroke({ color: "red", width: 3 }),
          }),
        }),
      };

      var vectorLayer = new VectorLayer({
        source: this.vectorSource,
        style: function(feature) {
          return styles[feature.get("size")];
        },
      });

      const centerLonLat = [-99.881972, 39.024467];
      const centerWebMercator = fromLonLat(centerLonLat);
      var baseLayer = new TileLayer({ source: new OSM() });

      var map = new Map({
        target: "mapOL",
        layers: [baseLayer, vectorLayer],
        view: new View({
          center: centerWebMercator,
          zoom: 4,
        }),
      });

      map.addInteraction(selectClick);
      map.addInteraction(selectPointerMove);
      selectClick.on("select", (e) => {
        this.handleClick(e);
      });
    },
  },
  props: {
    sources: Array,
  },
  data() {
    return {
      selectedIds: [],
      vectorSource: new VectorSource({
        features: [
          new Feature({
            geometry: new Point(fromLonLat([-99.881972, 39.024467])),
            size: "8",
            id: "id",
            name: "name",
            height: "height",
            volume: "volume",
          }),
        ],
        wrapX: false,
      }),
    };
  },
  watch: {
    sources: function(sources) {
      console.log("calculating map with sources: " + sources);
      this.callCalculateMap(sources);
    },
    selectedIds: function() {
      // get source by ID
      var latestId = this.selectedIds[this.selectedIds.length - 1];
      var source = this.sources.find((s) => {
        return s.id == latestId;
      });
      if (source != null) {
        this.$emit("selectSource", source);
      } else {
        console.log("Couldn't find source with id: " + latestId);
        console.log(JSON.stringify(this.sources, null, "  "));
        this.sources.forEach(function(element) {
          console.log(element.id);
        });
        this.$emit("selectSource", null);
      }
    },
  },
  mounted() {
    this.initMap();
    // this.callCalculateMap(this.sources);
  },
};
</script>

<style scoped lang="stylus">
@import "~ol/ol.css"
#mapOL
    height 500px
</style>
